import { __assign } from "tslib";
import React from 'react';
import { CnBaseTable } from '@cainiaofe/cn-ui';
export var CnMiniTable = function (props) {
    return React.createElement(CnBaseTable, __assign({}, props));
};
